var $ = require( "jquery" );
require('fslightbox');

import { Splide } from '@splidejs/splide';
import { Fancybox } from "@fancyapps/ui";



document.addEventListener('DOMContentLoaded', function() {
  var carousel = document.getElementById('carousel');
  if (carousel !== null && carousel !== undefined) {
    new Splide(carousel, {
      type         : 'loop',
      autoplay     : 'true',
      interval: 10000,
      pauseOnHover : true,
      arrows: false,
      resetProgress: false,
      drag: true
    }).mount();
  }
});


Fancybox.bind('[data-fancybox="gallery"]', {
  Thumbs: {
    Carousel: {
      fill: false,
      center: true,
    },
  },
});


document.addEventListener('DOMContentLoaded', function() {
  var msaPartners = document.getElementById('msa_partners');
  if (msaPartners !== null && msaPartners !== undefined) {
    new Splide(msaPartners, {
      perPage    : 3,
      trimSpace: true,
      rewind     : true,
      pagination : false,
      drag: true,
      gap: 16,
      breakpoints: {
        1300: {
          perPage    : 3,
        },
        800: {
          perPage    : 2,
        },
        500: {
          perPage    : 1,
        },  
      }   
    }).mount();
  }
});



  document.getElementById('search').addEventListener('click', function() {
    document.getElementById("search-modal").classList.add('search-modal__active');
});

  document.getElementById("close-modal").addEventListener('click', function() {
    document.getElementById("search-modal").classList.remove('search-modal__active');
});



(function ($) {
  $(function () {
   
    $('.main-nav__item a:not(:only-child)').on('click',function (e) {
      
      
      // Chiudi un menu a discesa quando ne selezioni un altro
      
        $(this).siblings('.sub-menu').toggle();
    

      // $('.active22').not($(this).siblings()).hide();




      //  $('.sub-menu').not($(this).siblings()).hide();
      e.stopPropagation();
    });
    // clic fuori dal menu a discesa rimuoverà la classe a discesa
    $('html').on('click',function () {
      $('.sub-menu').hide();
    });
    // Attiva / disattiva  al clic
    $('#nav-toggle').on('click',function () {
      $('nav ul').slideToggle();
    });
    // toggle Hamburger
    $('#nav-toggle').on('click', function () {
      this.classList.toggle('active');
    });
  });
})(jQuery);









(function ($) {
  $(function () {
    $('.topnav__item a:not(:only-child)').on('click', function (e) {
      $(this).siblings('.sub-menu').toggle();
      // Chiudi un menu a discesa quando ne selezioni un altro
      // $('.sub-menu').not($(this).siblings()).hide();
      e.stopPropagation();
    });
    // clic fuori dal menu a discesa rimuoverà la classe a discesa
    $('html').on('click', function () {
      $('.sub-menu').hide();
    });

  });
})(jQuery);




(function ($) {
  $(function () {
    $('.main-nav__mobile-item a:not(:only-child)').on('click', function (e) {
      $(this).siblings('.sub-menu').toggle();
      // Chiudi un menu a discesa quando ne selezioni un altro
      // $('.sub-menu').not($(this).siblings()).hide();
      e.stopPropagation();
    });
    // clic fuori dal menu a discesa rimuoverà la classe a discesa
    $('html').on('click', function () {
      $('.sub-menu').hide();
    });

  });
})(jQuery);


(function ($) {
  $(function () {
    $('.footer-nav-vertical__item a:not(:only-child)').on('click', function (e) {
      $(this).siblings('.sub-menu').toggle();
      // Chiudi un menu a discesa quando ne selezioni un altro
      // $('.sub-menu').not($(this).siblings()).hide();
      e.stopPropagation();
    });
    // clic fuori dal menu a discesa rimuoverà la classe a discesa
    $('html').on('click', function () {
      $('.sub-menu').hide();
    });

  });
})(jQuery);

(function ($) {
  $(function () {
    $('.footer-nav-horizontal__item a:not(:only-child)').on('click', function (e) {
      $(this).siblings('.sub-menu').toggle();
      // Chiudi un menu a discesa quando ne selezioni un altro
      // $('.sub-menu').not($(this).siblings()).hide();
      e.stopPropagation();
    });
    // clic fuori dal menu a discesa rimuoverà la classe a discesa
    $('html').on('click', function () {
      $('.sub-menu').hide();
    });

  });
})(jQuery);



window.addEventListener("resize", function ()  {
  let intViewportWidth = window.innerWidth;
  if (intViewportWidth > 1400) {
    
    document.getElementById("main-nav__mobile").classList.remove("main-nav__mobile-active");
  }
});


document.getElementById("header__burger-menu").addEventListener('click', function () {





  if (document.getElementById("main-nav__mobile").classList.contains("main-nav__mobile-active")) {

    document.getElementById("main-nav__mobile").classList.remove("main-nav__mobile-active");
    document.getElementById("header__burger-icon").classList.remove("header__nav-services-icon-active");
  } else {
    document.getElementById("main-nav__mobile").classList.add("main-nav__mobile-active");

    document.getElementById("header__burger-icon").classList.add("header__nav-services-icon-active");

    window.onclick = (e) => {
      if (!e.target.matches('.main-nav__mobile-container ') && !e.target.matches('.menu-menu-principale-container ') && !e.target.matches('.main-nav__mobile-item ') && !e.target.matches('.main-nav__mobile-content ') && !e.target.matches('.header__burger-menu ') && !e.target.matches('.header__nav-services-icon ') && !e.target.matches('.header__nav-services-label ')) {
        
        document.getElementById("main-nav__mobile").classList.remove("main-nav__mobile-active");
        document.getElementById("header__burger-icon").classList.remove("header__nav-services-icon-active");
       } else {

       }
     }

  }

});


/* ========================================== 
scrollTop() >= 300
Should be equal the the height of the header
========================================== */



$(window).on('scroll', function() {
  var header = $('#header');
  var headerHeight = header.outerHeight();

  if ($(window).scrollTop() >= 400 && !header.hasClass('header__fixed') && headerHeight > 0) {
    header.addClass('header__fixed');
    $('body').css('padding-top', headerHeight);
  } else if ($(window).scrollTop() < 400 && header.hasClass('header__fixed')) {
    header.removeClass('header__fixed');
    $('body').css('padding-top', 0);
  }
});


/* ==========================================
dropdown single page
========================================== */
if (document.getElementById("button-share")) {
const buttonShare = document.getElementById('button-share');
const dropMenus = document.getElementById('drop-menu');


buttonShare.addEventListener('click', function () {
    dropMenus.classList.toggle('drop-menu--active');

  })



window.onclick = (e) => {
  if (!e.target.matches('.button-share')) {
    dropMenus.classList.remove('drop-menu--active');
}
}

}

if (document.getElementById("button-share-event")) {
  const buttonShare = document.getElementById('button-share-event');
  const dropMenus = document.getElementById('drop-menu-event');


  buttonShare.addEventListener('click', function () {
    dropMenus.classList.toggle('drop-menu--active');

  })



  window.onclick = (e) => {
    if (!e.target.matches('.button-share')) {
      dropMenus.classList.remove('drop-menu--active');
    }
  }

}


 let menuParent = document.querySelector(".main-nav");
 Array.from(menuParent.children).forEach((menuItem) => {
     if (menuItem.children.length > 1) {
         menuItem.children[0].addEventListener("click", () => {
             Array.from(menuParent.children).forEach((subMenuItem) => {
                 if (subMenuItem != menuItem) {
                     if (subMenuItem.children.length > 1) {
                         subMenuItem.children[1].style.display = "none";
                     }
                 }
             })
         })
     }
 })





// selezionare tutti gli elementi "li" nell'elenco con id "nav_sezioni_persone"
var listaElementi = document.querySelectorAll('#nav_sezioni_persone li');

// selezionare tutte le sezioni da osservare
var sezioni = document.querySelectorAll('#msa_persone_sezioni section');

// creare un observer
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      // rimuovere la classe "current_page_item" da tutti gli elementi "li"
      listaElementi.forEach(function(elemento) {
        elemento.classList.remove('current_page_item');
      });
      // trovare l'elemento "a" corrispondente alla sezione in vista e aggiungere la classe "current_page_item" al suo genitore "li"
      var aCorrispondente = document.querySelector('a[href="#' + entry.target.id + '"]');
      if (aCorrispondente) {
        var liCorrispondente = aCorrispondente.parentNode;
        liCorrispondente.classList.add('current_page_item');
      }
    }
  });
}, { threshold: 0.5 });

// osservare ciascuna sezione
sezioni.forEach(function(sezione) {
  observer.observe(sezione);
});

// Gestire il click sulle voci di menu
listaElementi.forEach(function(elemento) {
  elemento.addEventListener('click', function(e) {
    e.preventDefault();
    var href = this.querySelector('a').getAttribute('href');
    var sezioneCorrispondente = document.querySelector(href);
    if (sezioneCorrispondente) {
      sezioneCorrispondente.scrollIntoView({ behavior: 'smooth' });
    }
  });
});